export default "__VITE_ASSET__DPEVOw45__"